<div class="esf-spinner flex-container-loading" *ngIf="loading">
  <div class="row">
    <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
  </div>
</div>
<div *ngIf="!loading">
  <h2 class="esf-heading--section" i18n='Text in the step process@@createCustomerComponent.stepProcess.duplicateCheck'>Duplicate check</h2>
  <p i18n='Text in the step process@@createCustomerComponent.paragraph.foundDuplicates'>We have found duplicates, check the data to avoid customer duplicates.</p>

  <h2 class="esf-heading--sub-section" i18n='Section heading@@createCustomerComponent.sectionHeading.newCustomerData'>New customer data</h2>
  <table class="esf-table">
    <thead class="esf-table__head">
      <tr class="esf-table__row">
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.name' data-label="Name">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.name'>Name</span>
        </th>
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.birthday' data-label="Birthday">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.birthday'>Birthday</span>
        </th>
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.email' data-label="Email">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.email'>Email</span>
        </th>
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.phone' data-label="Phone">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.phone'>Phone</span>
        </th>
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.mobile' data-label="Mobile">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.phone'>Mobile</span>
        </th>
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.address' data-label="Address">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.address'>Address</span>
        </th>
      </tr>
    </thead>
    <tbody class="esf-table__body">
      <tr class="esf-table__row">
        <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.name' data-label="Name">
          <span class="esf-table__cell-inner">{{ customer.firstName }} {{ customer.lastName }}</span>
        </td>
        <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.birthday' data-label="Birthday">
          <span class="esf-table__cell-inner">{{ customer.birthday?.date | date: 'dd.MM.yyyy'}}</span>
        </td>
        <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.email' data-label="Email">
          <span class="esf-table__cell-inner">{{ customer.email }}</span>
        </td>
        <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.phone' data-label="Phone">
          <span class="esf-table__cell-inner">{{ customer.phone }}</span>
        </td>
        <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.mobile' data-label="Mobile">
          <span class="esf-table__cell-inner">{{ customer.mobile }}</span>
        </td>
        <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.address' data-label="Address">
          <span class="esf-table__cell-inner" *ngIf="address.street && address.postalCode">
            {{ address.street }}, {{ address.postalCode }}
          </span>
          <span class="esf-table__cell-inner" *ngIf="!(address.street && address.postalCode)"> </span>
        </td>
      </tr>
    </tbody>

    <tbody class="esf-table__body">
      <tr style="background-color: transparent;">
        <td style="padding-left: 0" colspan="5">
          <h2 class="esf-heading--sub-section" i18n='Section heading@@createCustomerComponent.sectionHeading.possibleDUplicates'>Possible duplicates</h2>
          <p class="esf-paragraph" i18n='Text in the step process@@createCustomerComponent.paragraph.selectDuplicates'>Select one of the duplicate rows to work with this customer instead</p>
        </td>
      </tr>
    </tbody>

    <thead class="esf-table__head">
      <tr class="esf-table__row">
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.name' data-label="Name">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.name'>Name</span>
        </th>
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.birthday' data-label="Birthday">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.birthday'>Birthday</span>
        </th>
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.email' data-label="Email">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.email'>Email</span>
        </th>
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.phone' data-label="Phone">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.phone'>Phone</span>
        </th>
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.mobile' data-label="Mobile">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.phone'>Mobile</span>
        </th>
        <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.address' data-label="Address">
          <span class="esf-table__cell-inner" i18n='Table cell heading@@general.tableCellLabel.address'>Address</span>
        </th>
      </tr>
    </thead>
    <tbody class="esf-table__body">
      <tr class="esf-table__row esf-table__row--is-clickable" *ngFor="let duplicate of listOfDuplicates" (click)="confirmModal(duplicate.id)">
        <td class="esf-table__cell" data-label="Name" i18n-data-label='Table cell heading@@general.tableCellLabel.name'>
          <span class="esf-table__cell-inner">{{ duplicate.firstName }} {{ duplicate.lastName }}</span>
        </td>
        <td class="esf-table__cell" data-label="Birthday" i18n-data-label='Table cell heading@@general.tableCellLabel.birthday'>
          <span class="esf-table__cell-inner">{{ duplicate.birthday | date: 'dd.MM.yyyy' }}</span>
        </td>
        <td class="esf-table__cell" data-label="Email" i18n-data-label='Table cell heading@@general.tableCellLabel.email'>
          <span class="esf-table__cell-inner">{{ duplicate.email }}</span>
        </td>
        <td class="esf-table__cell" data-label="Phone" i18n-data-label='Table cell heading@@general.tableCellLabel.phone'>
          <span class="esf-table__cell-inner">{{ duplicate.phone }}</span>
        </td>
        <td class="esf-table__cell" data-label="Phone" i18n-data-label='Table cell heading@@general.tableCellLabel.mobile'>
          <span class="esf-table__cell-inner">{{ duplicate.mobile }}</span>
        </td>
        <ng-container *ngIf="duplicate.addresses.length">
          <td class="esf-table__cell" data-label="Address" i18n-data-label='Table cell heading@@general.tableCellLabel.address'>
            <ng-container *ngFor="let address of duplicate.addresses">
              <span class="esf-table__cell-inner" *ngIf="address.type === 'standard'">
                <span>{{ address.street }}, {{ address.postalCode }}</span>
              </span>
            </ng-container>
          </td>
        </ng-container>
        <ng-container *ngIf="!(duplicate.addresses.length)">
          <td class="esf-table__cell" data-label="Address" i18n-data-label='Table cell heading@@general.tableCellLabel.address'>
            <span class="esf-table__cell-inner"></span>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>

</div>
